






































import Vue from 'vue';
import ImportEntry from '../components/import/Entry.vue';
import ImportUpload from '../components/import/Upload.vue';
import ImportConfig from '../components/import/Config.vue';
import ImportSuccess from '../components/import/Success.vue';
import ImportFail from '../components/import/Fail.vue';
import customerVuex from '../vuex/common';
import customerClient from '../apis';
import commonClient from '../../common/apis';
import { CustomerImport, CustomerMergeProp } from '../models/CustomerImport';

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    ImportEntry,
    ImportUpload,
    ImportConfig,
    ImportSuccess,
    ImportFail,
  },
  data() {
    return {
      succeeded: false,
      failed: false,
      startSync: false,
      started: false,
      stat: null,
      loaded: false,
      showEntry: true,
      taskId: null,
    };
  },
  computed: {
    currentStep(): number {
      if (this.succeeded) {
        return 3; 
      } else if (this.startSync) {
        return 2;
      } else if (this.customerImport.excelUrl) {
        return 1;
      } else {
        return 0;
      }
    },
  },
  methods: {
    loadPropsOfFields() {
      customerClient.getProps().success((r) => {
        this.$store.commit('SET_CUSTOMER_PROPS', r.props);
      });
    },
    onSuccess(params: any) {
      this.stat = params.stat;
      this.taskId = params.id;
      this.succeeded = true;
    },
    onFail(id: number) {
      this.taskId = id;
      this.failed = true;
    },
    onRestart() {
      this.failed = false;
      this.$store.commit('RESET_CUSTOMER_IMPORT');
    },
    onContinue() {
      this.succeeded = false;
      this.failed = false;
      this.started = false;
      this.startSync = false;
      this.onRestart();
    },
    loadTask() {
      commonClient.getTasksByTypes({
        page: 1,
        size: 1,
        tpes: [11],
      }).success(r => {
        if (r.tasks && r.tasks.length > 0 && !r.tasks[0].confirmed) {
          const fi = r.tasks[0]['taskInput']['FieldImport'];
          const columns = Object.keys(fi.props).concat(fi.keyColumn);
          const ci = {
            excelUrl: fi.excelUrl,
            keyColumn: fi.keyColumn,
            keyProp: fi.keyProp,
            props: fi.props,
            columns: columns,
          } as CustomerImport;
          this.$store.commit('SET_CUSTOMER_IMPORT', ci);
          this.showEntry = false;
          if (r.tasks[0].result === 0) {
            this.stat = r.tasks[0]['taskOutput']['FieldImportStat'];
            this.taskId = r.tasks[0]['id'];
            this.succeeded = true;
          } else if (r.tasks[0].result === -1) {
            this.taskId = r.tasks[0]['id'];
            this.failed = true;
          } else {
            this.started = true;
          }
        }
        this.loaded = true;
      });
    },
  },
  mounted() {
    this.loadPropsOfFields();
    this.loadTask();
  },
});
